import axios from 'axios';
import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import constants from 'constants';
import actions from 'actions';
import { toast } from 'react-toastify';
import { push } from 'redux-router';

const {
  addErrorsSaga,
} = actions;

const {
  FORGOT_PASSWORD_SAGA,
  API_FORGOT_PASSWORD
} = constants;

const apiForgotPassword = (email) => (
  axios.post(API_FORGOT_PASSWORD, {
    email
  })
);

function* forgotPassword({ email }) {
  try {
    const response = yield call(apiForgotPassword, email);
    yield call(toast.success, response.data.message);
    yield put(push('/'));
  } catch (e) {
    yield put(addErrorsSaga(FORGOT_PASSWORD_SAGA, e.response))
  }
}

function* __forgotPasswordSaga() {
  yield takeEvery(FORGOT_PASSWORD_SAGA, forgotPassword)
}

export {
  __forgotPasswordSaga
};



/** WEBPACK FOOTER **
 ** ./src/sagas/forgotPassword.js
 **/